import React from 'react';
import PropTypes from 'prop-types';
import {
  Avatar,
  Grid,
  useTheme,
} from '@mui/material';
import { formatCurrency } from 'utils/formatter.js';
import StatBox from 'components/StatBox';
import OrderIcon from 'assets/icons/loads.png';
import PaymentIcon from 'assets/icons/payment.png';
import InvoiceIcon from 'assets/icons/invoice.png';
import NetIcon from 'assets/icons/saving.png';
import { tokens } from 'theme/tokens';

const ReportSummary = ({ orderSummaryStats, invoiceSummaryStats, invoiceCountStats, billSummaryStats, billCountStats, operationalExpenses, netStats }) => {

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  let totalOrderCount = 0;
  let totalInvoiceAmount = 0;
  let totalBillPaymentAmount = 0;
  let totalOperationalExpenses = 0;

  let invoiceData = [];
  let billPaymentData = [];
  let orderCountData = [];
  if (orderSummaryStats) {
    totalOrderCount = Object.values(orderSummaryStats).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    orderCountData = Object.entries(orderSummaryStats).map(([k, v]) => ({ 'status': k, 'value': v }));
  }
  if (invoiceSummaryStats) {
    totalInvoiceAmount = Object.values(invoiceSummaryStats).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    invoiceData = Object.entries(invoiceSummaryStats).map(([k, v]) => ({ 'status': k, 'value': formatCurrency(v), 'count': invoiceCountStats[k] }));
  }
  if (billSummaryStats) {
    totalBillPaymentAmount = Object.values(billSummaryStats).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    billPaymentData = Object.entries(billSummaryStats).map(([k, v]) => ({ 'status': k, 'value': formatCurrency(v), 'count': billCountStats[k] }));
  }
  if (operationalExpenses) {
    totalOperationalExpenses = operationalExpenses.reduce((acc, curVal) => acc + curVal.amount, 0,);
  }

  return (
    <Grid container spacing={1}>
      <Grid size={{ xs: 6, sm: 3 }}>
        <StatBox
          title='Orders'
          statHighlight={totalOrderCount}
          statBreakdown={orderCountData}
          icon={<Avatar src={OrderIcon} sx={{
            p: 1, background: colors.blue[500],
            '& .MuiAvatar-img': {
              filter: 'invert(1)',
            }
          }}
          />
          }
        />
      </Grid>
      <Grid size={{ xs: 6, sm: 3 }}>
        <StatBox
          title='Invoices'
          statHighlight={formatCurrency(totalInvoiceAmount, 'en-US', 'compact')}
          statBreakdown={invoiceData}
          icon={<Avatar src={InvoiceIcon}
            sx={{
              p: 1,
              background: colors.green[500],
              '& .MuiAvatar-img': {
                filter: 'invert(1)',
              }
            }}
          />}
        />
      </Grid>
      <Grid size={{ xs: 6, sm: 3 }}>
        <StatBox
          title='Driver Settlement'
          statHighlight={formatCurrency(totalBillPaymentAmount, 'en-US', 'compact')}
          statBreakdown={billPaymentData}
          icon={<Avatar
            src={PaymentIcon}
            sx={{
              p: 1, background: colors.green[500],
              '& .MuiAvatar-img': {
                filter: 'invert(1)',
              }
            }}
          />
          }
        />
      </Grid>
      <Grid size={{ xs: 6, sm: 3 }}>
        <StatBox
          title='Net'
          statHighlight={formatCurrency(netStats.Net, 'en-US', 'compact')}
          statBreakdown={[
            { status: 'invoice', value: formatCurrency(netStats.InvoiceTotal) },
            { status: 'bills', value: formatCurrency(netStats.PaymentTotal) },
            { status: 'Expenses', value: formatCurrency(totalOperationalExpenses) }
          ]}
          icon={<Avatar
            src={NetIcon}
            sx={{
              p: 1,
              background: colors.indigo[300],
              '& .MuiAvatar-img': {
                filter: 'invert(1)',
              }
            }}
          />
          }
        />
      </Grid>
    </Grid>
  );
};

ReportSummary.propTypes = {
  className: PropTypes.string
};

export default ReportSummary;